<template>
  <svg :fill="fillColor"
       class="material-design-icon__svg"
       viewBox="0 0 24 24">
    <path d="M3,3H21V5H3V3M9,7H21V9H9V7M3,11H21V13H3V11M9,15H21V17H9V15M3,19H21V21H3V19Z"/>
  </svg>
</template>

<script>
export default {
  name: "FormatAlignRightIcon",
  props: {
    fillColor: {
      type: String,
      default: "currentColor"
    },
  }
}
</script>
